export const OrDivider = () => {
  const svgStyle = {
    fill: 'var(--color-brand-colors-white, #FFF)',
    strokeWidth: '1px',
    stroke: 'var(--color-neutral-500, #DEE0EB)',
  };
  return (
    <div className="flex items-center justify-center w-full mb-8 mt-2">
      <div className="w-full bg-neutral-500 h-px" />
      <span className="mx-4 text-neutral-900 text-center font-figtree text-sm leading-5">Or</span>
      <div className="w-full bg-neutral-500 h-px" />
    </div>
  );
};
